const NAMES = {
    ["APPLE_STORE" /* STORES.APPLE_STORE */]: 'App Store',
    ["GOOGLE_PLAY" /* STORES.GOOGLE_PLAY */]: 'Google Play',
    ["HUAWEI_APP_GALLERY" /* STORES.HUAWEI_APP_GALLERY */]: 'HUAWEI AppGallery',
    ["RU_STORE" /* STORES.RU_STORE */]: 'RuStore',
};
const HREFS = {
    ["APPLE_STORE" /* STORES.APPLE_STORE */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/appstore/?placement=ios_footer_install',
    ["GOOGLE_PLAY" /* STORES.GOOGLE_PLAY */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/googleplay/?placement=android_footer_install',
    ["HUAWEI_APP_GALLERY" /* STORES.HUAWEI_APP_GALLERY */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/huaweiAppGallery/?placement=huaweiappgallery_footer_install',
    ["RU_STORE" /* STORES.RU_STORE */]: 'https://www.sravni.ru/analytics-links/v1/redirects/mobileapps/rustore/?placement=rustore_footer_install',
};

export { HREFS, NAMES };
//# sourceMappingURL=stores.js.map
